/**
 * Map public tour request fields to ListingOnboardingForm local state and which steps to skip.
 */
export interface TourRequestPrefillInput {
  listing_address: string
  rent: string
  bedrooms: string
  bathrooms: string
  phone_number: string
  neighborhood: string
  /** Original listing page URL if the landlord provided one; omit when not collected */
  listing_url?: string
  /** Set when the landlord already uploaded to a `PendingListing` in the public tour flow */
  pending_listing_id?: string
}

export function buildTourRequestPrefillPatch(
  tour: TourRequestPrefillInput
): {
  formPatch: {
    address: string
    rent: string
    bedrooms: string
    bathrooms: string
    customerPhone: string
    title: string
    description: string
  }
  skippedIds: Set<string>
} {
  const phoneDigits = tour.phone_number.replace(/\D/g, '')
  const hasValidPhone = phoneDigits.length >= 10

  const skippedIds = new Set<string>(['rent', 'address', 'bedrooms', 'bathrooms'])
  if (hasValidPhone) {
    skippedIds.add('customerPhone')
  }
  if (tour.pending_listing_id) {
    skippedIds.add('listing_photos')
  }

  return {
    formPatch: {
      address: tour.listing_address,
      rent: tour.rent,
      bedrooms: tour.bedrooms,
      bathrooms: tour.bathrooms,
      customerPhone: hasValidPhone ? phoneDigits : '',
      title: '',
      description: '',
    },
    skippedIds,
  }
}
